// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1gDAw","containerItemsCenter":"Skeleton_containerItemsCenter__1NF78"};